__webpack_require__.p = "https://thegeorgiavoterguide.com/";